import { SET_ART_WALL_ACTIVE_PRODUCT } from './../const';

export default (artWallActiveProduct) => {
  return {
    type: SET_ART_WALL_ACTIVE_PRODUCT,
    artWallActiveProduct: artWallActiveProduct
  }
};
